module.exports = __webpack_public_path__ + "static/flaming_fist_duskguard_mtg_ahbg-b78d64969aaad3c8fce3348b4bf67d91.webp";